module.exports = __webpack_public_path__ + "img/idigi-lelangnet.80697378.png";